export class DashboardCountStatus {
  constructor(
    public mealTypeId: string,
    public received: boolean = false,
    public served: boolean = false,
    public exists: boolean = false,
    public affirmed: boolean = false,
    public drafts: boolean = false) {
  }
}
